const KeenSlider = window.KeenSlider

const { setInitialised, useCounter, useProgress } = window.BAO.Carousel.plugins

class MahinaPreviewMobile extends window.BAO.CustomElement() {
  connectedCallback () {
    super.connectedCallback()

    this.carousel = this.setupCarousel()
  }

  setupCarousel () {
    return new KeenSlider(
      this.els.slides.element,
      {
        selector: this.els.slide.selector,
        defaultAnimation: {
          duration: 1500,
        },
        loop: false,
        mode: 'snap',
        slides: {
          perView: 1.2,
          spacing: 16,
        },
      },
      [
        setInitialised(),
        useCounter({
          counter: this.els?.counter?.element,
        }),
        useProgress({
          container: this.els?.progress?.element,
          progressbar: this.els?.progressbar?.element,
        }),
      ],
    )
  }
}

if (!customElements.get('mahina-preview-mobile')) {
  customElements.define('mahina-preview-mobile', MahinaPreviewMobile)
}
